import { FamilyConnectionRequest, FamilyMemberNew } from 'src/modules/member/models/familyMember';
import { MemberFamilyMemberPutRequest, MemberFamilyPutRequest } from 'src/modules/member/models/formMemberFamilyPut';
import { setPagingParams } from '../functions/createPagingParams';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setArrayValue } from '../functions/setArrayValue';

const controller = 'Family';

export const getFamily = (pageIndex, pageSize, sortCol, sortDir, memberId) => {
  const endpoint = `${controller}?member_id=${memberId}&${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;

  return AxiosInstance.get<PagedResult<FamilyMemberNew>>(endpoint);
};

export const createFamilyConnections = (connections: FamilyConnectionRequest[]) => {
  const endpoint = `${controller}/List`;
  return AxiosInstance.post<FamilyMemberNew>(endpoint, connections);
};

export const deleteFamily = (familyId: number, req: MemberFamilyPutRequest) => {
  let extraQuery = '';
  extraQuery += req.idsToSecede !== undefined ? setArrayValue(req.idsToSecede, 'resignFamilyMemberIds') : '';
  extraQuery += req.resCause !== undefined ? `&resCause=${req.resCause}` : '';
  extraQuery += req.resDate !== undefined ? `&resDate=${req.resDate}` : '';
  const endpoint = `${controller}/Cancel/${familyId}?${extraQuery.substring(1)}`;

  return AxiosInstance.put(endpoint);
};

export const deleteFamilyMember = (id, req: MemberFamilyMemberPutRequest) => {
  let extraQuery = '';
  extraQuery += req.idToSecede !== undefined ? `&resignFamilyMemberId=${req.idToSecede}` : '';
  extraQuery += req.resCause !== undefined ? `&resCause=${req.resCause}` : '';
  extraQuery += req.resDate !== undefined ? `&resDate=${req.resDate}` : '';
  const endpoint = `${controller}/${id}/Cancel?${extraQuery.substring(1)}`;
  return AxiosInstance.put<FamilyMemberNew>(endpoint);
};

export const changeMainMember = (memberId: number) => {
  const endpoint = `${controller}/ChangeMainMember/${memberId}`;
  return AxiosInstance.put(endpoint);
};
